import React, { useState, useEffect } from "react";
import ReactExport from "react-export-excel";
import { translate } from 'react-multi-lang';
import { SyncOutlined, PercentageOutlined, LeftOutlined, EditOutlined, DeleteOutlined, SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import {Table, Tooltip, Popconfirm, Modal, Form, Row, Col, Select, Button, Input, InputNumber, Divider, Switch, DatePicker, Space, message } from 'antd';

import { AllHtmlEntities } from 'html-entities';
import moment from 'moment';
import 'moment/locale/ca';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const entities = new AllHtmlEntities();

function OpenDaysExportaExcel(props){

  const [dades, setDades] = useState(props.dades);
  const nom_fulla = props.nom_fulla ? props.nom_fulla : props.t('menu.OpenDays');
  const nom_fitxer = props.nom_fitxer ? props.nom_fitxer : props.t('menu.OpenDays');

  useEffect(() => {
    setDades(props.dades)
  },[props.dades]);

  //console.log("dins exporta: ", props.dades)

  return (
      <ExcelFile
        filename={nom_fitxer}
        element={<Button type="primary" style={{backgroundColor: '#217346', borderColor: '#217346', marginBottom: '0.5rem', marginLeft: '0.5rem', marginRight: '0.5rem'}} shape="round" icon={<FileExcelOutlined />}>{props.btn_txt}</Button>}>
          <ExcelSheet data={dades} name={nom_fulla}>
            <ExcelColumn label="Id" value="id_open_days"/>
            <ExcelColumn label={props.t('generic.data')} value={(col) => moment(col.dia_triat).format('DD/MM/YYYY')}/>
            <ExcelColumn label={props.t('generic.nom')} value={(col) => entities.decode(col.name)}/>
            <ExcelColumn label={props.t('pares.cognoms')} value={(col) => entities.decode(col.surnames)}/>
            <ExcelColumn label={props.t('pares.email')} value={"email"}/>
            <ExcelColumn label={props.t('pares.tel1')} value={"phone"}/>
            <ExcelColumn label={props.t('generic.alumne')+'_1'} value={(col) => col.fills[0] ? entities.decode(col.fills[0].name_student) : ''}/>
            <ExcelColumn label={props.t('alumnes.naixement')+'_1'} value={(col) =>  col.fills[0] ?  moment(col.fills[0].date_student).format('DD/MM/YYYY') : ''}/>
            <ExcelColumn label={props.t('generic.curs')+'_1'} value={(col) => col.fills[0] ? entities.decode(col.fills[0].nom_curs) : ''}/>

            <ExcelColumn label={props.t('generic.alumne')+'_2'} value={(col) => col.fills[1] ? entities.decode(col.fills[1].name_student) : ''}/>
            <ExcelColumn label={props.t('alumnes.naixement')+'_2'} value={(col) =>  col.fills[1] ?  moment(col.fills[1].date_student).format('DD/MM/YYYY') : ''}/>
            <ExcelColumn label={props.t('generic.curs')+'_2'} value={(col) => col.fills[0] ? entities.decode(col.fills[0].nom_curs) : ''}/>

            <ExcelColumn label={props.t('generic.alumne')+'_3'} value={(col) => col.fills[2] ? entities.decode(col.fills[2].name_student) : ''}/>
            <ExcelColumn label={props.t('alumnes.naixement')+'_3'} value={(col) =>  col.fills[2] ?  moment(col.fills[2].date_student).format('DD/MM/YYYY') : ''}/>
            <ExcelColumn label={props.t('generic.curs')+'_3'} value={(col) => col.fills[0] ? entities.decode(col.fills[0].nom_curs) : ''}/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.created_at).tz('Europe/Madrid').format('DD/MM/YYYY HH:mm')}/>
          </ExcelSheet>
      </ExcelFile>
  );

}

export default translate(OpenDaysExportaExcel);
